<template>
	<div class="modal is-active">
		<div class="modal-background"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title">Text Link</p>
				<button class="delete" aria-label="close" @click="goBack"></button>
			</header>
			<form @submit.prevent="onSubmit()">

				<section class="modal-card-body">

					<div class="field">
						<div class="control">
							<input class="input" type="text" v-model="name" required placeholder="Descrição">
						</div>
					</div>
					<div class="field">
						<div class="control">
							<input class="input" type="url" v-model="url" required placeholder="URL" @keyup="validate" title="Insira um URL (endereço digital visível na barra de navegação de seu browser. Ex: www.gmail.com)">
						</div>
					</div>

				</section>

				<footer class="modal-card-foot">
					<button type="submit" class="button is-success">Salvar</button>
					<button class="button" @click.prevent="goBack">Cancel</button>
					<button v-if="item" class="button is-danger" @click.prevent="onDelete">Excluir</button>
				</footer>
			</form>
		</div>
	</div>
</template>


<script>
// @ is an alias to /src

import firebase from '@/firebase'
export default {
	props:['item'],
	data() {
		return {
			name: '',
			url: 'http://',
		}
	},
	computed: {
		userId() {
			return this.$store.getters.userId;
		},
	},
	methods:{
		validate(){
			if(this.url.match(/^https?:\/\/https?:\/\//)){
				this.url = this.url.replace(/https?:\/\/(https?:\/\/)/,'$1');
			}
		},
		goBack(){
			this.$router.push({name:'home'});
		},

		onSubmit(){

			var data = {
				name:this.name,
				url:this.url,
			};

			if(this.item){
				this.$store.dispatch('updateTextlink',{textlink_id:this.item.id,data:data});
			} else {
				this.$store.dispatch('addTextlink',{data:data});
			}

			//popup para registrar usuário anonimo
			if(askRegisterAnonymous(this.$store.state)) {
				this.$router.push({name:'formRegistrar'});
				return;
			}


			this.goBack();

		},
		onDelete(){
			if(!confirm('Tem certeza?')) return;
			this.$store.dispatch('deleteTextlink',{textlink_id:this.item.id});
			this.goBack();
		}
	},
	mounted() {
		if(this.item){
			this.name = this.item.name;
			this.url = this.item.url;
		}
	},
};
</script>


<style>
</style>
